module.exports = __webpack_public_path__ + "images/assets/06c333745276aea2d2191e436ca9eda4.svg";